import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axiosInstance from '../services/axiosConfig';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';

const SSOCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithSSO } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('Invalid SSO callback. No code provided.');
      return;
    }

    const exchangeCode = async () => {
      try {
        const response = await axiosInstance.post('/auth/sso/exchange', { code });
        const { token, user } = response.data;

        if (!token || !user) {
          throw new Error('Invalid response from server');
        }

        loginWithSSO(token, user);
        navigate('/dashboard');
      } catch (err: any) {
        console.error('[Partner SSO] Exchange error:', err);
        setError(err.response?.data?.message || 'SSO authentication failed. Please try again.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    exchangeCode();
  }, [searchParams, loginWithSSO, navigate]);

  if (error) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #63739c 0%, #aeb6bf 100%)' }}>
        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
        <Typography variant="body2" color="white">Redirecting to login...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #63739c 0%, #aeb6bf 100%)' }}>
      <CircularProgress size={48} sx={{ mb: 2, color: 'white' }} />
      <Typography variant="h6" color="white">Completing sign in...</Typography>
    </Box>
  );
};

export default SSOCallback;
